const stageOrigin = 'https://version2-stage.pixx.io';
const websiteOrigin = 'https://www.pixx.io';
export const approveOrigin = 'https://approve.px.media';
export const requestOrigin = (location.hostname === 'localhost' ? stageOrigin : (location.origin === websiteOrigin ? approveOrigin : location.origin));
export const configuration = (location.pathname.includes('configurationApi') ? 'configuration/' : '');
const defaultRequestConfig = {
    path: '',
    mainPath: requestOrigin + '/gobackend/' + configuration,
    method: 'get',
    parameters: {},
    setDefaultHeader: true,
    useURLSearchParams: true
};
export class Api {
    calling(resolve, reject, config = Object.assign({}, defaultRequestConfig)) {
        const requestParameters = config.parameters;
        let params = requestParameters;
        if (config.useURLSearchParams) {
            params = new URLSearchParams();
            for (let [key, value] of Object.entries(requestParameters)) {
                if (typeof value === 'object') {
                    value = JSON.stringify(value);
                }
                params.set(key, value);
            }
            params = params.toString();
        }
        const headers = new Headers();
        if (config.setDefaultHeader) {
            headers.set('Content-Type', 'application/x-www-form-urlencoded');
        }
        const handleResponse = (data) => {
            if (data.ok) {
                resolve(data);
            }
            else {
                // TODO errorhandling
                reject(data);
            }
        };
        fetch(config.mainPath + config.path + (Object.keys(params).length ? '?' + params : ''), { method: config.method, headers })
            .then(handleResponse)
            .catch(handleResponse);
    }
    call(config = Object.assign({}, defaultRequestConfig)) {
        return new Promise((resolve, reject) => this.calling(resolve, reject, Object.assign({}, config)));
    }
    getPromiseConfig(config) {
        return new Promise((resolve, reject) => {
            const emit = (response) => {
                if (response.ok) {
                    response.text()
                        .then((text) => resolve(JSON.parse(text)))
                        .catch((error) => reject(error));
                }
                else {
                    reject(response);
                }
            };
            this.call(Object.assign(Object.assign({}, defaultRequestConfig), config))
                .then(emit)
                .catch(emit);
        });
    }
}
